import Link from 'next/link';

import { GROUPS } from '@/lib/routes/privateRoutes';

import { ListWrapper } from '@/components/composite/SocialProfiles/Components/ListWrapper';

import Icon from '@/components/base/Icon';

export function EmptyGroupsMenu() {
    return (
        <ListWrapper data-testid="empty-groups-menu">
            <Link
                data-testid="create-group-link"
                href={`${GROUPS}?create_group=true`}
                className="pendo-empty-group-menu flex h-10.5 w-10.5 items-center justify-center rounded-md border-2 border-white bg-icoBlue dark:border-icoDarkMode-deepBlack dark:bg-icoBlue/20">
                <Icon icon="plus" className="text- !text-white" />
            </Link>
            {Array.from({ length: 4 }).map((_, index) => (
                <div
                    data-testid="empty-group-menu-item"
                    className="h-10.5 w-10.5 rounded-md border-2 border-white bg-white/40 dark:border-icoDarkMode-deepBlack"
                    key={index}
                />
            ))}
        </ListWrapper>
    );
}
